/**
 * Custom Box Item Popup
 * Shows a popup for products with 'custom_box_item' tag that prevents individual purchase
 */

class CustomBoxItemPopup {
  constructor() {
    this.init();
  }

  init() {
    // Check if we're on a product page - try multiple methods
    const isProductPage = document.body.classList.contains('template-product') || 
                         window.location.pathname.includes('/products/') ||
                         document.querySelector('#product-tags') !== null;
    
    if (isProductPage) {
      this.checkForCustomBoxItem();
    }
  }

  checkForCustomBoxItem() {
    // Get product data from the page
    const productData = this.getProductData();
    
    if (productData && productData.tags && productData.tags.includes('custom_box_item')) {
      this.showPopup();
    }
  }

  getProductData() {
    // Get product tags from the data attribute
    const productTagsElement = document.getElementById('product-tags');
    
    if (productTagsElement) {
      const tagsString = productTagsElement.getAttribute('data-tags');
      
      if (tagsString) {
        const tags = tagsString.split(',').map(tag => tag.trim());
        return {
          tags: tags
        };
      }
    }

    return null;
  }

  showPopup() {
    // Create popup overlay
    const overlay = document.createElement('div');
    overlay.id = 'custom-box-item-overlay';
    overlay.style.cssText = `
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: rgba(0, 0, 0, 0.8);
      z-index: 999999;
      display: flex;
      align-items: center;
      justify-content: center;
      font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
    `;

    // Create popup content
    const popup = document.createElement('div');
    popup.style.cssText = `
      background: white;
      padding: 40px;
      border-radius: 12px;
      max-width: 500px;
      width: 90%;
      text-align: center;
      box-shadow: 0 20px 40px rgba(0, 0, 0, 0.3);
      position: relative;
    `;

    // Create popup content HTML
    popup.innerHTML = `
      <div style="margin-bottom: 20px;">
        <h2 style="color: #333; margin: 0 0 16px 0; font-size: 24px; font-weight: 600;">
          Custom Box Item
        </h2>
        <p style="color: #666; margin: 0 0 24px 0; font-size: 16px; line-height: 1.5;">
          This item cannot be purchased individually. Please click here to order it as part of a custom assortment.
        </p>
        <a href="https://gardnerscandies.com/products/custom-assortment" 
           style="display: inline-block; background-color: rgb(200,2,46); color: white; padding: 12px 24px; text-decoration: none; border-radius: 6px; font-weight: 600; font-size: 16px; transition: background-color 0.2s;">
          Order Custom Assortment
        </a>
      </div>
    `;

    // Add hover effect to button
    const button = popup.querySelector('a');
    button.addEventListener('mouseenter', () => {
      button.style.backgroundColor = '#b8941f';
    });
    button.addEventListener('mouseleave', () => {
      button.style.backgroundColor = '#d4af37';
    });

    // Append popup to overlay
    overlay.appendChild(popup);

    // Add to body
    document.body.appendChild(overlay);

    // Prevent body scroll
    document.body.style.overflow = 'hidden';

    // Hide product form buttons
    const productFormButtons = document.querySelector('.product-information .product-form-buttons');
    if (productFormButtons) {
      productFormButtons.style.display = 'none';
    }

    // Prevent any clicks on the overlay from closing the popup, but allow link clicks
    overlay.addEventListener('click', (e) => {
      // Allow clicks on links to work normally
      if (e.target.tagName === 'A' || e.target.closest('a')) {
        return; // Let the link work normally
      }
      
      // Prevent all other clicks
      e.preventDefault();
      e.stopPropagation();
    });

    // Prevent any keyboard shortcuts that might close the popup
    document.addEventListener('keydown', this.preventEscape, true);
  }

  preventEscape(e) {
    // Prevent ESC key and other common close shortcuts
    if (e.key === 'Escape' || (e.key === 'w' && e.metaKey) || (e.key === 'q' && e.metaKey)) {
      e.preventDefault();
      e.stopPropagation();
    }
  }

  destroy() {
    const overlay = document.getElementById('custom-box-item-overlay');
    if (overlay) {
      overlay.remove();
      document.body.style.overflow = '';
      document.removeEventListener('keydown', this.preventEscape, true);
    }
  }
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new CustomBoxItemPopup();
  });
} else {
  new CustomBoxItemPopup();
}
